const firebaseConfig = {
  apiKey: "AIzaSyAf6EdcfUPwbktMjQDyqmEWSQLqQej_4qE",
  authDomain: "capstone-aba19.firebaseapp.com",
  databaseURL: "https://capstone-aba19-default-rtdb.firebaseio.com",
  projectId: "capstone-aba19",
  storageBucket: "capstone-aba19.appspot.com",
  messagingSenderId: "822915114434",
  appId: "1:822915114434:web:43a2a11acb98358fb0e25b",
};

export default firebaseConfig;
